export default {
  setPostIDs: 'I18N_MUTATIONS_SET_POST_IDS'
}
